import '@mui/material/styles'
import { createTheme } from '@mui/material/styles'

declare module '@mui/material/styles' {
  interface Palette {
    gradient: {
      primary: string
    }
    customColors: {
      mainBackground: string
    }
  }

  interface PaletteOptions {
    gradient: {
      primary: string
    }
    customColors?: {
      mainBackground: string
    }
  }
}

const theme = createTheme({
  typography: {
    fontFamily: '"Fira Sans", sans-serif',
    h1: {
      fontSize: '1.5rem',
      fontWeight: 700
    },
    h2: {
      fontSize: '1.3rem',
      fontWeight: 'bold'
    },
    body1: {
      fontSize: '1rem'
    }
  },
  palette: {
    primary: {
      main: '#0098d8'
    },
    text: {
      primary: '#626464',
      secondary: '#555555'
    },
    gradient: {
      primary: 'linear-gradient(to right bottom, #08CBEF, #0098d8)'
    },
    customColors: {
      mainBackground: '#f9fafb'
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 770,
      md: 815,
      lg: 1200,
      xl: 1536
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          padding: '8px',
          textAlign: 'center',
          borderRadius: '10px'
        })
      }
    }
  }
})

export default theme
